module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "A Note on the Writing of this Book"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "id1526948"
    }
  }, [_vm._v("A Note on the Writing of this Book")])]), _c('a', {
    attrs: {
      "id": "id1526948"
    }
  })]), _c('a', {
    attrs: {
      "id": "id1526948"
    }
  })]), _c('a', {
    attrs: {
      "id": "id1526948"
    }
  })]), _c('a', {
    attrs: {
      "id": "id1526948"
    }
  }, [_c('p', [_vm._v("This book really IS about gross stuff. And that’s a tricky subject! Because when it\n                comes to grossness, there is an invisible line between “hilariously funny” and\n                “going too far.” And just to make things interesting, that invisible line is\n                different from person to person.")]), _vm._v(" "), _c('p', [_vm._v("This means that this book is almost guaranteed to make you laugh "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("and ")])]), _vm._v("to actually gross you out. But, hey, don’t chicken out now! After all, I had\n                to be brave just to write all this stuff. You see, as this book’s author, I face a\n                unique danger. People might link ME with the disgusting things I’m writing\n                about!")]), _vm._v(" "), _c('p', [_vm._v("Not wanting to be contaminated in this way, I’ve taken special steps to ensure that I\n                myself am "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("in no way gross")])]), _vm._v(". So during the writing of this book, I stopped manufacturing:")]), _vm._v(" "), _c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("mucus")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("dandruff")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("tweets from my Twitter")])])])]), _vm._v(" "), _c('p', [_vm._v("Furthermore, I showered twice daily. This process included exfoliation, defoliation,\n                and deforestation. (Plus, I scrubbed between my toes!)")]), _vm._v(" "), _c('p', [_vm._v("Finally, before sitting down to write, I looked at pictures of kittens, flowers, and\n                puppies. This helped purify and protect my mind from the horrible topics that my\n                cruel editor forced me to research.")]), _vm._v(" "), _c('p', [_vm._v("As you can see, I have sacrificed a lot for this book, but as long as you do not\n                associate me with grossness, it will have been worth it. And please don’t link the\n                following people with gross stuff either, even though they did help with this book:\n                Lynn King, Matt Grow, MD, Parker Swanson, Virginia and Dallas Wassink, Michael\n                Milone, the Groh family, Jeff Holiman, Chuck Shepherd, Carolyn Wood, Nancy Tipton,\n                MD, Taewon and Philip Laplante, Jennifer C. Felton, MD, Robert Rowzee, Andrew R.\n                Brown, MD, Michelle Herrmann, Robert Wilkes, Mary McLean, Annemarie Plaizier,\n                Destiny Covington-Zawasky, Jennifer Blair, Kathleen Twomey, Tama Filipas, Dean\n                Hanson, Lorraine Roosevelt, Don Sisler, Katy Killilea, Robin Henderson Thomas, Katie\n                Greenseth, Dee Roosevelt, Christine Mathews, Tiffany Denman, Dave Sohigian, Debbie\n                Alvarez, Jared Smith, Madge Baird, and Suzanne Taylor.")]), _vm._v(" "), _c('p', [_vm._v("Well, as you’re about to find out, it’s a gross, gross world out there. Let’s learn\n                all about it!")])])]), _c('a', {
    attrs: {
      "id": "id1526948"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee45c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 69
// module chunks = 0